<div class="profile-page">
    <section class="profile-hero">
        <div class="hero-bg"></div>
        <div class="hero-overlay"></div>
        <div class="container hero-inner">
            <div class="hero-copy">
                <h1>Player Command Center</h1>
                <p>Track your progress, badges, rank, and latest match rewards in one place.</p>
            </div>
        </div>
    </section>

    <section class="profile-shell" *ngIf="user && user.userAccountDto; else profileLoading">
        <div class="container">
            <div class="top-grid">
                <article class="player-card">
                    <div class="player-header">
                        <img src="assets/img/badges/trophy.png" alt="Player Badge">
                        <div>
                            <h2>{{ user.userAccountDto.user.name || user.userAccountDto.user.userName }}</h2>
                        </div>
                    </div>
                    <div class="player-points">
                        <span>Total Points</span>
                        <strong>{{ user.userAccountDto.points || 0 }}</strong>
                    </div>
                    <div class="micro-stats">
                        <div>
                            <span>Badges</span>
                            <strong>{{ user.userAccountDto.badgeList?.length || 0 }}</strong>
                        </div>
                        <div>
                            <span>Activities</span>
                            <strong>{{ user.userAccountDto.rewardList?.length || 0 }}</strong>
                        </div>
                        <div>
                            <span>Phone</span>
                            <strong>{{ user.userAccountDto.user.phoneNumber || 'N/A' }}</strong>
                        </div>
                    </div>
                </article>

                <article class="ranking-card">
                    <div class="ranking-head">
                        <h3>Points & Ranking</h3>
                        <a routerLink="/leaderboard">Overall History <i class="fa fa-arrow-right"></i></a>
                    </div>
                    <div class="ranking-grid" *ngIf="leaderboardLoaded && userAccounts.length > 0; else rankingFallback">
                        <div class="rank-pill">
                            <span>Overall Rank</span>
                            <strong>{{ userRank }}</strong>
                        </div>
                        <div>
                            <span>Top Score</span>
                            <strong>{{ topPoints }}</strong>
                        </div>
                        <div>
                            <span>Leaderboard Players</span>
                            <strong>{{ userAccounts.length }}</strong>
                        </div>
                        <div>
                            <span>Gap To #1</span>
                            <strong>{{ pointsGapToTop }}</strong>
                        </div>
                    </div>
                </article>
            </div>

            <div class="content-grid">
                <article class="module-card">
                    <h4>Personal Details</h4>
                    <div class="details-list">
                        <div><span>Username</span><strong>{{ user.userAccountDto.user.userName }}</strong></div>
                        <div><span>Phone</span><strong>{{ user.userAccountDto.user.phoneNumber || 'Not provided' }}</strong></div>
                        <div><span>Status</span><strong>{{ user.userAccountDto.user.status }}</strong></div>
                    </div>
                </article>

                <article class="module-card">
                    <h4>Badges Unlocked</h4>
                    <div *ngIf="user.userAccountDto.badgeList?.length; else noBadges" class="badge-grid">
                        <div class="badge-item" *ngFor="let badge of user.userAccountDto.badgeList">
                            <img src="assets/img/badges/medal-1.png" alt="Badge">
                            <div>
                                <strong>{{ badge.name || 'Badge' }}</strong>
                                <p>{{ badge.description || 'Achievement unlocked!' }}</p>
                            </div>
                        </div>
                    </div>
                </article>

                <article class="module-card wide">
                    <h4>Recent Activities</h4>
                    <div *ngIf="user.userAccountDto.rewardList?.length; else noActivities" class="table-wrap">
                        <table>
                            <thead>
                            <tr>
                                <th>Category</th>
                                <th>Points</th>
                                <th>Status</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let reward of user.userAccountDto.rewardList">
                                <td data-label="Category">{{ reward.category }}</td>
                                <td data-label="Points">{{ reward.pointValue }}</td>
                                <td data-label="Status">{{ reward.status || 'Completed' }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </article>

                <article class="module-card wide">
                    <div class="module-head">
                        <h4>Leaderboard Snapshot</h4>
                        <a routerLink="/leaderboard">View Full Board</a>
                    </div>
                    <div *ngIf="leaderboardLoaded && userAccounts.length > 0; else noLeaders" class="table-wrap">
                        <table>
                            <thead>
                            <tr>
                                <th>Rank</th>
                                <th>Player</th>
                                <th>Points</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let userAccount of userAccounts; let i = index">
                                <td data-label="Rank">
                                    <img *ngIf="i < 3" [src]="'assets/img/badges/medal-' + (i + 1) + '.png'" alt="Medal" class="medal-image">
                                    <span *ngIf="i >= 3">{{ i + 1 }}</span>
                                </td>
                                <td data-label="Player">{{ userAccount.user.userName }}</td>
                                <td data-label="Points">{{ userAccount.points }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </article>
            </div>
        </div>
    </section>

    <ng-template #profileLoading>
        <div class="container state-msg">Loading profile...</div>
    </ng-template>

    <ng-template #rankingFallback>
        <div class="state-msg small">Loading ranking stats...</div>
    </ng-template>

    <ng-template #noBadges>
        <p class="state-msg small">No badges yet. Keep playing to unlock your first one.</p>
    </ng-template>

    <ng-template #noActivities>
        <p class="state-msg small">No activity recorded yet.</p>
    </ng-template>

    <ng-template #noLeaders>
        <p class="state-msg small">Leaderboard data unavailable.</p>
    </ng-template>
</div>
